<template>
  <span data-toggle="tooltip" class="d-inline-block tooltip-hover-target"
        title="This card has expired" v-if="expired">
    <div :class="containerCssClass">
      <div class="brand-logo"></div>

      <div class="tdesk-stored-credit-card-inner-container">
        <span :class="textCssClass">
          Exp. {{exp_month}}/{{exp_year.substring(2,4)}}
          <i class="fas fa-exclamation-triangle"></i>
        </span>
        <span :class="textCssClass">Ending in {{last_4_digits}}</span>
      </div>
    </div>
  </span>

  <div :class="containerCssClass" @click="setActive()" v-else>
    <div class="brand-logo"></div>

    <div class="tdesk-stored-credit-card-inner-container">
        <span :class="textCssClass">
          Exp. {{exp_month}}/{{exp_year.substring(2,4)}}
        </span>
      <span :class="textCssClass">Ending in {{last_4_digits}}</span>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      active: {required: true},
      paymentMethodId: {required: true},
      last_4_digits: {required: true},
      brand: {required: true},
      expired: {required: true},
      exp_month: {required: true},
      exp_year: {required: true}
    },
    computed: {
      containerCssClass() {
        return {
          'tdesk-stored-credit-card': true,
          active: this.active,
          'disabled': this.expired
        }
      },
      textCssClass() {
        return {
          'tdesk-body--small': true,
          'tdesk-neutral-ultradark': !this.active,
          'tdesk.brand': this.active
        }
      }
    },
    mounted() {
      if (this.expired) {
        $('[data-toggle="tooltip"]').tooltip();
      }
    },
    methods: {
      setActive() {
        this.$emit('select-card', this.paymentMethodId)
      }
    }
  }
</script>
